import React from "react";
import { useTranslation } from "react-i18next";

function About() {
  const { t } = useTranslation("homepage");

  return (
    <section className="tc-about-style10 section-padding-x overflow-hidden">
      <div className="container-fluid">
        <div className="content section-padding border-top borderd">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="img">
                <img
                  src="/home10/assets/img/about.png"
                  alt="Botanicheska 302"
                  className="img-contain wow fadeInUp"
                  data-wow-delay="0.2s"
                />
                <div className="years-box wow zoomIn" data-wow-delay="0.5s">
                  <h4>{t("about.completionYear")}</h4>
                  <span className="text-uppercase color-666">
                    {t("about.completionText")}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="info">
                <div
                  className="section-head-style10 mb-50 wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <h2 className="fsz-40">
                    {t("about.title")
                      .replace(/(botanicheska 302)/i, " ###$1### ") // tag and add a space before
                      .split(/(###.*?###)/)
                      .map((part, index) => {
                        if (part.startsWith("###") && part.endsWith("###")) {
                          const cleanText = part.replace(/###/g, "").trim();
                          return (
                            <span
                              key={index}
                              style={{ fontFamily: "TheSeasons" }}
                            >
                              {cleanText}
                            </span>
                          );
                        }
                        return <span key={index}>{part}</span>;
                      })}
                  </h2>
                </div>
                <div
                  className="text color-666 fsz-21 wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  {t("about.description")
                    .split(/(botanicheska 302)/i)
                    .map((part, index) =>
                      part.toLowerCase() === "botanicheska 302" ? (
                        <span
                          key={index}
                          style={{
                            fontFamily: "TheSeasons",
                            textTransform: "uppercase",
                          }}
                        >
                          {part}
                        </span>
                      ) : (
                        part
                      )
                    )}
                </div>

                <a
                  href="/home7_landscape/"
                  className="butn borderd border rounded-pill mt-80 hover-bg-black wow fadeInUp"
                  data-wow-delay="0.7s"
                >
                  <span>
                    {t("about.learnMoreButton")}
                    <i className="small ms-1 ti-arrow-top-right"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee section */}
      <div className="about-maquee">
        <div className="swiper-wrapper">
          <div className="swiper-slide">
            <a href="#">{t("about.marquee.modernDesign")}</a>
          </div>
          <div className="swiper-slide">
            <a href="#">{t("about.marquee.seaPanorama")}</a>
          </div>
          <div className="swiper-slide">
            <a href="#">{t("about.marquee.greenEnvironment")}</a>
          </div>
          <div className="swiper-slide">
            <a href="#">{t("about.marquee.energyEfficiency")}</a>
          </div>
          <div className="swiper-slide">
            <a href="#">{t("about.marquee.smartTechnologies")}</a>
          </div>
          <div className="swiper-slide">
            <a href="#">{t("about.marquee.comfortQuality")}</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
